var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecipentEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8052 2.06081C10.9769 1.88913 11.1807 1.75294 11.405 1.66002C11.6293 1.56711 11.8697 1.51929 12.1125 1.51929C12.3553 1.51929 12.5957 1.56711 12.8201 1.66002C13.0444 1.75294 13.2482 1.88913 13.4199 2.06081C13.5916 2.2325 13.7278 2.43632 13.8207 2.66063C13.9136 2.88495 13.9614 3.12537 13.9614 3.36817C13.9614 3.61097 13.9136 3.85139 13.8207 4.0757C13.7278 4.30002 13.5916 4.50384 13.4199 4.67552L4.59523 13.5002L1 14.4807L1.98052 10.8855L10.8052 2.06081Z",
    stroke: "#454D66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipentEdit);
export default __webpack_public_path__ + "static/media/recipent-edit.55af5aebd42b73d2fe39ca91d60174af.svg";
export { ForwardRef as ReactComponent };